require('./bootstrap');

// Import modules...
import { createApp, h } from 'vue';
import { createI18n } from 'vue-i18n'
import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import mitt from 'mitt';
import numberHelper from './plugins/numberHelper'
import validationRules from './plugins/validationRules'
import store from '@/store/promo'
import vuetify from "./plugins/vuetify";

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'

const emitter = mitt();
const el = document.getElementById('app');

const i18n = createI18n({
    legacy: false,
    locale: i18nTranslations.locale,
    fallbackLocale: i18nTranslations.locale,
    messages: i18nTranslations.messages,
})

const app = createApp({
    render: () =>
        h(InertiaApp, {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: (name) => require(`./Pages/${name}`).default,
        }),
})

    .mixin({ methods: { route } })
    .use(InertiaPlugin)
    .use(i18n)
    .use(numberHelper)
    .use(vuetify)
    .use(store)
    .use(validationRules)
    .use(ToastPlugin)
    .use(VueJsonPretty);

app.config.globalProperties.emitter = emitter;
app.component('VueDatePicker', VueDatePicker);
app.mount(el);

InertiaProgress.init({ color: '#4B5563' });
